import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AuditTab() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <h2 className="display-heading font-black text-3xl">Audit Log</h2>
        <div className="kbd-label text-white/40 mt-1">EVERY MUTATION · APPEND-ONLY</div>
      </div>
      <div className="card-tactical overflow-x-auto">
        <table className="w-full text-sm font-mono">
          <thead>
            <tr className="kbd-label text-left text-white/50 border-b border-white/10">
              <th className="px-6 py-3">WHEN</th><th>ACTOR</th><th>ACTION</th><th>DETAILS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.created_at || ""}-${r.action || ""}-${i}`} className="border-b border-white/5">
                <td className="px-6 py-3 text-white/50 text-xs">{r.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="text-neon-cyan">{r.actor}</td>
                <td className="text-neon-yellow">{r.action}</td>
                <td className="text-white/60 truncate max-w-md">{JSON.stringify(r.details)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="px-6 py-6 text-white/40">No events.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
